<div class="col-lg-12 col-md-12">
    <div class="courses-info">
        <a routerLink="/ofertas-listar" class="default-btn"><i class="fas fa-search"></i>Ver todas los trámites<span></span></a>
    </div>
</div>